// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PrescriptionModel {
    static getAttributeTypeMap() {
        return PrescriptionModel.attributeTypeMap;
    }
}
PrescriptionModel.discriminator = undefined;
PrescriptionModel.additionalProperties = false;
PrescriptionModel.attributeTypeMap = [
    {
        "name": "id",
        "baseName": "id",
        "type": "number"
    },
    {
        "name": "accountId",
        "baseName": "accountId",
        "type": "number"
    },
    {
        "name": "createdBy",
        "baseName": "createdBy",
        "type": "number"
    },
    {
        "name": "createdOn",
        "baseName": "createdOn",
        "type": "Date"
    },
    {
        "name": "updatedBy",
        "baseName": "updatedBy",
        "type": "number"
    },
    {
        "name": "updatedOn",
        "baseName": "updatedOn",
        "type": "Date"
    },
    {
        "name": "isDeleted",
        "baseName": "isDeleted",
        "type": "boolean"
    },
    {
        "name": "signatures",
        "baseName": "signatures",
        "type": ""
    },
    {
        "name": "externalIds",
        "baseName": "externalIds",
        "type": ""
    },
    {
        "name": "documentId",
        "baseName": "documentId",
        "type": "number"
    },
    {
        "name": "prescriberId",
        "baseName": "prescriberId",
        "type": "number"
    },
    {
        "name": "ndcId",
        "baseName": "ndcId",
        "type": "number"
    },
    {
        "name": "dispenseTypeId",
        "baseName": "dispenseTypeId",
        "type": "number"
    },
    {
        "name": "writtenOn",
        "baseName": "writtenOn",
        "type": "Date"
    },
    {
        "name": "daySupply",
        "baseName": "daySupply",
        "type": "number"
    },
    {
        "name": "refills",
        "baseName": "refills",
        "type": "number"
    },
    {
        "name": "quantity",
        "baseName": "quantity",
        "type": "number"
    },
    {
        "name": "directions",
        "baseName": "directions",
        "type": "string"
    },
];
//# sourceMappingURL=prescriptionModel.js.map